import { Action, createReducer, on } from "@ngrx/store";
import * as QuoteActions from "../quote.actions";
import {
  createEmptyQuoteFeatureState,
  QuoteFeatureState,
} from "../quote.state";

import { QuoteReducerMapperService } from "./mapper/quote-reducer-mapper.service";

const reducer = createReducer(
  createEmptyQuoteFeatureState(),
  ///////////////////////////////////////////////////////////////////////////////
  // Quote - Business Actions
  ///////////////////////////////////////////////////////////////////////////////

  on(QuoteActions.submitQuote, (state, action) =>
    QuoteReducerMapperService.createQuoteState(state, action.state),
  ),

  on(QuoteActions.lockQuote, (state, action) => ({
    ...state,
    applicationId: action.applicationId,
  })),

  on(QuoteActions.storeQueryStringParameters, (state, action) => ({
    ...state,
    dataAnalyticsCampaign: action.dataAnalyticsCampaign,
    attributionCode: action.attributionCode,
  })),

  ///////////////////////////////////////////////////////////////////////////////
  // Quote - Chain Reaction Actions
  ///////////////////////////////////////////////////////////////////////////////

  // GET (Quote)
  on(QuoteActions.getQuoteStart, (state) => ({
    ...state,
    error: undefined,
    isBusy: true,
  })),
  on(QuoteActions.getQuoteSuccess, (state, action) =>
    QuoteReducerMapperService.mapQuoteSuccessResponseToState(
      state,
      action,
      action.productConfiguration,
    ),
  ),
  on(QuoteActions.getQuoteFail, (state, action) => ({
    ...state,
    error: action.error,
    isBusy: false,
  })),

  // CREATE (Quote)
  on(QuoteActions.createQuoteStart, (state) => ({
    ...state,
    error: undefined,
    isBusy: true,
  })),
  on(QuoteActions.createQuoteSuccess, (state, action) =>
    QuoteReducerMapperService.mapQuoteSuccessResponseToState(
      state,
      action,
      action.productConfiguration,
    ),
  ),
  on(QuoteActions.createQuoteFail, (state, action) => ({
    ...state,
    error: action.error,
    isBusy: false,
  })),

  // UPDATE (Quote)
  on(QuoteActions.updateQuoteStart, (state) => ({
    ...state,
    error: undefined,
    isBusy: true,
  })),
  on(QuoteActions.updateQuoteSuccess, (state, action) =>
    QuoteReducerMapperService.mapQuoteSuccessResponseToState(
      state,
      action,
      action.productConfiguration,
    ),
  ),
  on(QuoteActions.updateQuoteFail, (state, action) => ({
    ...state,
    error: action.error,
    isBusy: false,
  })),

  // GET (Product Configuration)
  on(QuoteActions.getProductConfigurationStart, (state) => ({
    ...state,
    error: undefined,
    isBusy: true,
  })),
  on(
    QuoteActions.getProductConfigurationSuccess,
    (state, productionConfiguration) =>
      QuoteReducerMapperService.mapProductConfigurationSuccessResponseToState(
        state,
        productionConfiguration,
      ),
  ),
  on(QuoteActions.getProductConfigurationFail, (state, action) => ({
    ...state,
    error: action.error,
    isBusy: false,
  })),
);

export function featureReducer(
  state: QuoteFeatureState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
